import {FilterWrapperProps} from "./filter-wrapper.types";

export const FilterWrapperComponent = ({children, label}: FilterWrapperProps) => {
    return <div className="flex align-items-center justify-content-start">
        <div className="w-20rem p-2 font-bold">{label}</div>
        {children}
    </div>
}

